import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Modal from 'react-modal';
import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signup from './components/UserManagement/SignUp';
import Login from './components/UserManagement/Login';
import EmailConfirm from './components/UserManagement/EmailConfirmation';
import ResetPassword from './components/UserManagement/ResetPassword';
import FgtPswdChangeSuccessPg from './components/UserManagement/FgtPswdChangeSuccessPg';
import EmailVerification from './components/UserManagement/EmailVerification';
import ForgotPassword from './components/UserManagement/ForgotPassword';
import ThemeLayoutsComponent from './theme-layouts/themeLayouts';
import NotFoundPage from './components/shared-components/NotFoundPage';
import { CircularProgress } from '@mui/material';
import CircleLoader from 'react-spinners/CircleLoader';
import PrivateRoutes from '../src/utils/PrivateRoutes';

const SESSION_KEY = 'activeSession';
const TAB_ID_KEY = 'tabId';

const App = () => {
  // const ROUTE_PREFIX = '/onehubconnect';
  const [isSessionBlocked, setIsSessionBlocked] = useState(false);
  const [currentTabId, setCurrentTabId] = useState('');

  useEffect(() => {
    const savedSession = localStorage.getItem(SESSION_KEY);
    const tabId = sessionStorage.getItem(TAB_ID_KEY);

    if (!tabId) {
      // Assign a unique ID to this tab if none exists
      const newTabId = generateUUID();
      sessionStorage.setItem(TAB_ID_KEY, newTabId);
      setCurrentTabId(newTabId);

      if (!savedSession) {
        // No existing session, create a new one
        localStorage.setItem(SESSION_KEY, newTabId);
      } else if (savedSession !== newTabId) {
        // If another session exists, block this tab
        setIsSessionBlocked(true);
      }
    } else if (savedSession && savedSession !== tabId) {
      // Block if session mismatch
      setIsSessionBlocked(true);
    }

    // Listen for storage changes (other tabs opening)
    const handleStorageChange = (event) => {
      if (event.key === SESSION_KEY && event.newValue !== currentTabId) {
        setIsSessionBlocked(true);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Cleanup session on tab close
    const handleTabClose = () => {
      const activeSession = localStorage.getItem(SESSION_KEY);
      if (activeSession === sessionStorage.getItem(TAB_ID_KEY)) {
        localStorage.removeItem(SESSION_KEY);
      }
      sessionStorage.removeItem(TAB_ID_KEY);
    };

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, [currentTabId]);

  const handleCloseSession = () => {
    localStorage.removeItem(SESSION_KEY); // Clear session globally
    sessionStorage.removeItem(TAB_ID_KEY); // Remove current tab's identifier
    if (window.opener) {
      window.close(); // Close opened tabs
    } else {
      alert('This tab cannot be closed automatically. Please close it manually.');
    }
  };

  return (
    <div>
      <ToastContainer autoClose={2000} theme='dark' />
      <Router>
        <Routes>
          <Route index element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/' element={<Login />} />
          <Route path='/verifyEmail' element={<EmailVerification />} />
          <Route path='/forgotpassword' element={<ForgotPassword />} />
          <Route path='/emailconfirm' element={<EmailConfirm />} />
          <Route path='/resetpassword' element={<ResetPassword />} />
          <Route path='/passwordsuccess' element={<FgtPswdChangeSuccessPg />} />
          <Route element={<PrivateRoutes />}>
            <Route path='/*' element={<ThemeLayoutsComponent />} />
          </Route>
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      </Router>
      <Modal
        isOpen={isSessionBlocked}
        ariaHideApp={false}
        contentLabel='Session Blocked'
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            backgroundColor: '#134285',
            color: 'white',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            textAlign: 'center'
          }
        }}>
        <h2 style={{ marginBottom: '2rem' }}>Oops! You're Already Logged In</h2>
        <p>It looks like you already have an active session open in this browser.</p>
        <p>Try switching to that tab or refreshing the page to continue.</p>
      </Modal>
    </div>
  );
};

const generateUUID = () => {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
};

export default App;
